import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from '../../locales/i18n';

import './PricingsField.css';

const PricingsField = ({ name, pricings, onChange, multi, placeholder, excludeId, value }) => {
    const { t } = useTranslation();

    if (!pricings)
        return null;

    const filtered = excludeId
        ? pricings.filter(pricing => pricing.id !== excludeId)
        : pricings;

    const options = filtered.map(pricing => {
        return {
            key: pricing.id,
            text: Utils.localized_or_fallback(pricing.name, i18n.language, pricing.id),
            value: pricing.id
        };
    });

    options.sort((a, b) => a.text.localeCompare(b.text));

    if (multi) {
        return (
            <MultiSelectField
                name={name}
                options={options}
                placeholder={placeholder || t('pricinglists.pricing.pricing_choice')}
                onSelectChange={onChange}
            />
        );
    }

    return (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ placeholder || t('pricinglists.pricing.pricing_choice') }
            onSelectChange={ onChange }
            clearable
            noField={ !name }
            value={ name ? undefined : value }
        />
    )
}

export default PricingsField;
